import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import StaticMetaTags from 'Components/StaticMetaTags'
import { useConfiguration } from 'Root/ConfigurationProvider'
import {
  ManageHeader,
  SideMenu,
  SideLink,
  BodyContainer,
} from '../../components'

import FavListings from './components/FavListings'
import FavBuildings from './components/FavBuildings'

import { tabs } from './data.js'

import {
  _FavoriteMain,
  _FavoriteHeader,
  _TitleAndManageBtn,
  _Tabs,
  _Tab,
  _MainContent,
  _TitleInner,
} from './styles'

const Favourite = ({
  favPageData,
  loadUserFavourites, getUserFavIds, isFetching, openModal,
  userFavs,
  googleAnalyticsEvent, isMobile, isMobileApp, isUserAgentAdminSupport,
}) => {
  const {
    SITE_NAME, THEME_NAME, IS_CONDOS, PROPERTY_TYPE_PLURAL,
  } = useConfiguration()

  const {
    listings: favouriteListings,
    archive_listings: favouriteArchivedListings,
    buildings: favouriteBuildings,
  } = favPageData || {}

  useEffect(() => {
    loadUserFavourites()
    getUserFavIds()
  }, [])

  const {
    listings: userFavListingsObj = {},
    buildings: userFavBuildingsObj = {},
  } = userFavs || {}

  const userFavListingMlsArr = Object.keys(userFavListingsObj)
  const userFavBuildingIdArr = Object.keys(userFavBuildingsObj).map(id => parseInt(id, 10))


  const allFavouriteListings = [
    ...(favouriteListings && userFavListingMlsArr ?
      favouriteListings.filter(listing => userFavListingMlsArr.includes(listing.mls_number)) : []
    ),
    ...(favouriteArchivedListings && userFavListingMlsArr ?
      favouriteArchivedListings.filter(listing => userFavListingMlsArr.includes(listing.mls_number)) : []
    ),
  ]
  const listingCount = allFavouriteListings ? allFavouriteListings.length : 0
  const buildingCount = userFavBuildingIdArr ? userFavBuildingIdArr.length : 0
  const [favTab, setFavTab] = useState('listings')
  return (
    <_FavoriteMain tabIndex="-1">
      <StaticMetaTags
        title={`${SITE_NAME}.ca - Favourites`}
        image={`/static/images/${THEME_NAME}_blured_bg.jpg`}
        description={
          `Search & Analyze All ${PROPERTY_TYPE_PLURAL} for Sale & Rent.
            See historical SQFT trends & market analysis for ${PROPERTY_TYPE_PLURAL}.`
        }
        url={`https://${THEME_NAME}.ca/manage/favourite`}
      />

      <ManageHeader isMobile={isMobile} isMobileApp={isMobileApp}>
        <_FavoriteHeader>
          <SideMenu asFiller />
          <_TitleAndManageBtn>
            <_TitleInner align={'center'} justify={'between'} isMobile={isMobile} isMobileApp={isMobileApp}>
              <h1>Your Favourites</h1>
            </_TitleInner>
            <_Tabs>
              {
                IS_CONDOS ?
                  Object.keys(tabs).map(key => (
                    <_Tab
                      active={favTab === tabs[key]}
                      onClick={() => setFavTab(tabs[key])}
                      key={key}
                    >
                      {tabs[key]}
                      <span>
                        &nbsp;{tabs[key] === tabs.LISTINGS ? listingCount : buildingCount}
                      </span>
                    </_Tab>
                  ))
                  :
                  <_Tab>
                    {tabs.LISTINGS}
                    <span> {listingCount}</span>
                  </_Tab>
              }
            </_Tabs>
          </_TitleAndManageBtn>
        </_FavoriteHeader>
      </ManageHeader>
      <BodyContainer>
        <SideMenu>
          <div>
            <SideLink url={'/manage/profile'} iconName={'close'} label={'Profile'} />
            <SideLink url={'/manage/saved-alert'} iconName={'close'} label={'Saved Alerts'} />
            <SideLink url={'/'} iconName={'close'} label={'Affordability Calculator'} />
            <SideLink url={'/manage/favourite'} iconName={'close'} label={'Favourites'} />
          </div>
        </SideMenu>
        <_MainContent isMobileApp={isMobileApp}>
          {
            favTab === tabs.LISTINGS ?
              <FavListings
                allFavouriteListings={allFavouriteListings}
                isFetching={isFetching}
                openModal={openModal}
                userFavListingMlsArr={userFavListingMlsArr}
                googleAnalyticsEvent={googleAnalyticsEvent}
                isMobileApp={isMobileApp}
                isUserAgentAdminSupport={isUserAgentAdminSupport}
              />
              :
              <FavBuildings
                userIsAuthentificated
                favouriteBuildings={favouriteBuildings}
                isFetching={isFetching}
                userFavBuildingIdArr={userFavBuildingIdArr}
                isMobileApp={isMobileApp}
              />
          }

        </_MainContent>
      </BodyContainer>
    </_FavoriteMain>
  )
}

const favouriteObjectPropType = PropTypes.shape({
  note: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
})

Favourite.propTypes = {
  openModal: PropTypes.func,
  loadUserFavourites: PropTypes.func,
  favPageData: PropTypes.shape({
    listings: PropTypes.arrayOf(PropTypes.shape({})),
    archive_listings: PropTypes.arrayOf(PropTypes.shape({})),
    buildings: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isFetching: PropTypes.bool,
  userFavs: PropTypes.shape({
    listings: PropTypes.arrayOf(favouriteObjectPropType),
    buildings: PropTypes.arrayOf(favouriteObjectPropType),
  }),
  googleAnalyticsEvent: PropTypes.func,
  isMobile: PropTypes.bool,
  isMobileApp: PropTypes.bool,
  getUserFavIds: PropTypes.func,
  isUserAgentAdminSupport: PropTypes.bool,
}


export default Favourite

